import { colors } from 'theme'

export const defaultThemeStyles = {
    headerText: colors.darkBlue,
    tableBorder: colors.cloud,
}
